import { getCurrentCampaignCommon } from 'utils/models/Campaign';

export const getCurrentCampaignForKeyTakeaways = (
  additionalUrlParams?: object
) => {
  return (commonParams) => {
    getCurrentCampaignCommon({
      ...commonParams,
      urlParams: {
        include_talent_matrices: 'true',
        include_calibration_items: 'true',
        include_terminated_people: 'true',
        include_engagement_survey_results: 'true',
        ...(additionalUrlParams ?? {}),
      },
    });
  };
};
